import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Form from './Form';
import { create, reset } from '../../actions/PaymentMethod/create';

class PartnerAdminPaymentMethodCreate extends Component {
  static propTypes = {
    error: PropTypes.string,
    loading: PropTypes.bool.isRequired,
    created: PropTypes.object,
    create: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired
  };

  componentWillUnmount() {
    this.props.reset();
  }

  render() {
    if (this.props.created) {
      this.props.history.push({
        pathname: '../payment-methods',
        state: this.props.location.state,
      });
    }

    return (
      <div>

        {this.props.loading && (
          <div className="alert alert-info" role="status">
            Loading...
          </div>
        )}
        {this.props.error && (
          <div className="alert alert-danger" role="alert">
            <span className="fa fa-exclamation-triangle" aria-hidden="true" />{' '}
            {this.props.error}
          </div>
        )}

        <Form onSubmit={this.props.create} initialValues={{
          company: decodeURIComponent(this.props.match.params.id)
        }} />
        <button onClick={() => {
          this.props.history.push({
            pathname: '../payment-methods',
            state: this.props.location.state,
          });
        }} className="btn btn-primary float-left mr-3 mt-3">
          Back to list
        </button>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { created, error, loading } = state.paymentmethod.create;
  return { created, error, loading };
};

const mapDispatchToProps = dispatch => ({
  create: values => dispatch(create(values)),
  reset: () => dispatch(reset())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PartnerAdminPaymentMethodCreate);
